import styled from 'styled-components';

import { PADDING_CONTENT_PAGE } from '../../../globals';


export const StyledStatsSwitcher = styled.div`
  table {
    margin: 0px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;
  }

  td {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .tb-office-stats-left {
    text-align: right;
  }

  .tb-office-stats-switch {
    padding-right: 10px;
    padding-left: 10px;
  }

  .tb-office-stats-right {
    text-align: left;
  }
`;



// WEBPACK FOOTER //
// ./src/components/OfficeStats/styles/StyledStatsSwitcher.js